export default __webpack_public_path__ + "5fa6f311e65baf64f65013496e1f0370.png";